import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Debug logging
console.log('🔧 Supabase: Initializing', {
  url: supabaseUrl ? `${supabaseUrl.substring(0, 20)}...` : 'NOT SET',
  key: supabaseAnonKey ? `${supabaseAnonKey.substring(0, 20)}...` : 'NOT SET',
  willCreateClient: !!(supabaseUrl && supabaseAnonKey && 
    supabaseUrl !== 'your-supabase-url' && 
    supabaseAnonKey !== 'your-supabase-anon-key' &&
    supabaseUrl.trim() !== '' &&
    supabaseAnonKey.trim() !== ''),
})

// Client-side Supabase client
export const supabase = supabaseUrl && supabaseAnonKey && 
  supabaseUrl !== 'your-supabase-url' && 
  supabaseAnonKey !== 'your-supabase-anon-key' &&
  supabaseUrl.trim() !== '' &&
  supabaseAnonKey.trim() !== ''
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null
